/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/arrow_right'
export default icon
